import { Button,Collapse, Icon, Alert } from '@blueprintjs/core';
import React,{useState,useEffect} from 'react'
import Stack from './Stack';
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import db from '../firebase/config'
import Picker from 'emoji-picker-react';
import {setDoc,doc,collection, query, where, limit, onSnapshot, orderBy} from 'firebase/firestore'
import OneSignal from 'react-onesignal';
const axios = require('axios');
const uniqueId = require('react-unique-nums')
import { LinkPreview } from '@dhaiwat10/react-link-preview';
var moment = require('moment')
moment.utc().format(); 
const auth = getAuth()


function SharedCard(props) {
    const {title,owner_photo,owner_name,owner,timeStamp, itemDocId} = props.info

    let timeNew = new Date(timeStamp.seconds * 1000)
    const [visible,setVisible] = useState(false)
    const [stack,setStack] = useState("")
    const [disabled,setDisabled] = useState(true)
    const [user] = useAuthState(auth)
    const [show,setShow] = useState(false)
    const [allStacks,setAllStacks] = useState([])
    const [initial,setInitial] = useState(30)
    const [open,close] = useState(false)
    const [clipAlerts,setClipAlerts] = useState(false)


   const CopyToClipboardFn = async() => {
      navigator.clipboard.writeText(title);
      setClipAlerts(prev=>!prev);
    }

    useEffect(() => {
         if(stack === "") {setDisabled(true)} else setDisabled(false)
    },[stack])

    useEffect(() => {
         const unSubscribe = async () =>{

            const queryRef = query(
                collection(db, "stacks"),
                where("itemDocId","==",itemDocId),
                limit(initial),
                orderBy("timeStamp","asc")
           );

           await onSnapshot(queryRef,(snapshot) =>{
               let resArry = []
               if(snapshot.empty) {/*console.log("empty snapshot")*/}
               snapshot.forEach(doc =>{
                resArry.push({
                   id:doc.data().id,
                   title:doc.data().title,
                   label_id:doc.data().label_id,
                   stackDocId:doc.id,
                   owner:doc.data().owner,
                   owner_name:doc.data().owner_name,
                   owner_photo:doc.data().owner_photo,
                   timeStamp:doc.data().timeStamp
                   });
               })
               setAllStacks(resArry)
           })
         }
         unSubscribe()
         return()=>unSubscribe()
    },[])
    
    const sendStack = async ()=>{
          let stackId = uniqueId()
          let timeStamp = moment.utc()
          let docRef = doc(collection(db, "stacks"))
          await setDoc(docRef,{
            id:stackId,
            title:stack,
            owner:user.email,
            owner_name:user.displayName,
            owner_photo:user.photoURL,
            itemDocId:itemDocId,
            timeStamp:timeStamp._d
            });
            await setShow(true); await setStack("")

            // send notification to the owner of the item
            if(OneSignal.isPushNotificationsEnabled()){
                OneSignal.getUserId((player_id) => {
                    sendNofitication(player_id)
              })
            }
         
    }

    const onEmojiClick = (event, emojiObject) => {
            setStack(stack.concat(emojiObject.emoji));
      };


    const sendNofitication =(player_id) => {
        console.log('sendNofitication', player_id)
        var headers = {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "OWFiN2Q4NTEtNDVkNS00NDUwLWFjN2EtNzE4YWMwMTYwZjJh"
          };

        var options = {
            url: "onesignal.com",
            port: 443,
            path: "/api/v1/notifications",
            method: "POST",
          };
     
        var message = { 
          app_id: "e4272511-847d-423a-bb18-0a5012d60520",
          contents: {"en": "English Message"},
          include_player_ids: [player_id],
        };

        axios.post("https://"+options.url+options.path,{
              headers: headers,message,  
        }).then((response)=>{
            console.log(response,'response');
        }).catch((error)=>{console.log(error,'error')});

    }
    return (
        <div id="shared-card">
            <div id="just-bar">
                <img src={owner_photo} style={{width:50,height:50,borderRadius:25,margin:10}} />
                    <div>
                    <h3 style={{color: '#ecf1f5'}}>{owner_name}</h3>
                        <p style={{color: '#DDD',marginTop:-14,fontSize:9}}>{owner}</p>
                    </div>
                    <p id="caption">{moment.utc(timeNew).format('MMM Do YY, h:mm')}</p>
            </div>
             <p id="p" style={{marginLeft:'10%',paddingTop:-30,fontSize:20,paddingRight:12}}
                onClick={() => CopyToClipboardFn(title)}
                  >{title}</p>
                  <LinkPreview url={title} style={{margin:10}}/>
             <Button icon="layers" id="stack-btn" onClick={()=>setVisible(prev=>!prev)}>Stacks {allStacks.length <=0 ? "": allStacks.length} </Button>

                <Collapse isOpen={visible}>
                   <p style={{color:'#ecf1f5',paddingLeft:'10%'}}>Stacks are nested items</p>
                       {allStacks.length <=0 ? <div/> : 
                            <div>
                                {allStacks.map(item =>(
                                       <Stack info={item}  key={item.id}/>
                                ))}
                            </div>
                       }

                      <div id="just-bar-stack">
                            <button id="emoji"  onClick={()=>close(prev=>!prev)}><Icon icon="emoji" size={20} color="#ecf1f5" ></Icon></button>
                            <textarea placeholder="add stack" id="stack-input" value={stack}  onChange={e=>setStack(e.target.value)}/>
                            <button id="send"  onClick={()=>sendStack()} disabled={disabled}><Icon icon="send-message" size={20} color={disabled ? "#30404D":"#ecf1f5" }></Icon></button>
                      </div>

                      <Collapse isOpen={open}>
                        <Picker onEmojiClick={onEmojiClick}  
                                pickerStyle={{
                                    backgroundColor:'#30404D',
                                    color:'#30404D',
                                    marginLeft:'15%',width:'70%',
                                    overflow:'auto',borderWidth:0}}
                                    disableSearchBar={true} 
                                    preload={false}
                                     />
                      </Collapse>
                </Collapse>

                <Alert isOpen={show}  onClose={()=>setShow(prev=>!prev)}>
                  Stack successfully added
                </Alert>
                <Alert isOpen={clipAlerts} onClose={()=>setClipAlerts(prev=>!prev)}>
                   Copied to clipboard
                  </Alert>
        </div>
    )
}

export default SharedCard
